<template>
  <div class="">
    <div class="tableDiv">
      <div class="table-header"><span class="tableheading">PurchaseRequisitionView (1-25/26)</span> </div>
      <b-table class="requisit" striped hover :items="PendPR" :fields="fields" selectable
      @row-selected="onRowSelected">
      <template slot="selected">
        <img src="img/docimg.gif" />
    </template>
      <template #cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <a-checkbox :checked="rowSelected" @change="onChange">
          </a-checkbox>
        </template>
        <template v-else>
          <a-checkbox @change="onChange">
          </a-checkbox>
        </template>
      </template>
      </b-table>
      <span class="page"><span style="color:blue; margin-right: 5px;">1</span> 2</span>
    </div>



  </div>
</template>

<script>
export default {
  name: 'GroupRequisition',
  data() {
      return {
        fields: ['selected', 'Pur_Requisition_No', 'Pur_Requisition_Date', 'Pur_Requisition_Type', 'Ref_No', 'Authorized', 'Authorization_Stage'],
        PendPR: [
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/052/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '11', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/052/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '11', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/052/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '11', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/052/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '11', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/052/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '11', Authorized: 'Yes', Authorization_Stage: '3' },
        ],
        selected: [],
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
      }
    },
    methods: {
        onRowSelected(items) {
          this.selected = items
        },
        onChange(e) {
          this.checked = e.target.checked;
        },
      }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.group-btn{
      display: flex;
    width: 100%;
    justify-content: flex-end;
}
.firstcol{
  text-align: left;
  padding-left: 100px;
}
.firstcol .ant-checkbox-wrapper{
  padding-left: 50px;
}
.tableDiv{
  border: 1px solid;
  margin: 20px 0px 15px 5px;
  border-radius: 5px;
  text-align: left;
}
.table-header{
  background: #bdc7d6;
  text-align: left;
  border-bottom: 1px solid;
}
.tableimg{
  padding-left: 10px;
    padding-right: 10px;
    width: 30px;
    margin-top: -4px;
}
.tableheading{
  padding-left: 10px;
      font-size: 14px;
    font-weight: 700;
}
.table-body{
      text-align: center;
    padding: 5px;
}
.table-body select, .table-body input{
  border: 2px inset;
}
.page{
  padding-top: 5px !important;
  padding-left: 15px !important;
   font-weight:500;
    font-size: 12px;
}
.ielogo{
  width: 20px;
  margin-left: 5px;
}
.toolicons{
      position: absolute;
      right: 3px;
    top: -2px;
}
.toolicons .anticon{
      background: #c0c0c0;
    border: 2px outset;
    margin-right: 2px;
    color: #333;
}
.glass{
    position: relative;
    display: inline-block;
    padding: 2px 18px;
    border: 0;
    background-color: green;
    background-image: linear-gradient(#d8e1e9,#c1cfdc,#d8e1e9);
    text-decoration: none;
        color: #333;
    font-size: 12px;
    font-family: sans-serif;
    font-weight: 700;
    box-shadow: rgb(0 0 0 / 25%) 1.95px 1.95px 2.6px;
    border-radius: 15px;
    margin-right: 5px;
    max-width: 135px;
}
.green-glass{
  position: relative;
    display: inline-block;
    padding: 2px 18px;
    border: 0;
    background-color: green;
    background-image: linear-gradient(lightgreen,#66b266,lightgreen);
    text-decoration: none;
        color: #333;
    font-size: 12px;
    font-family: sans-serif;
    font-weight: 700;
    box-shadow: rgb(0 0 0 / 25%) 1.95px 1.95px 2.6px;
    border-radius: 15px;
    margin-right: 5px;
    max-width: 135px;
}
.table-body .ant-form-item{
  margin-bottom: 0;
}
.table-body .ant-form-item-label{
  text-align: left;
}
</style>
